export const santo = () => {
    return(
        <div>
            Компания SANTO использует программное обеспечение SAP и связанноое с ним решение Workday, где ведется кадровый учет. Также здесь используют и модуль 1С:Зарплата и Управление Персоналом. Мы связали Workday с 1С, благодаря чему избавили клиента от необходимости двойного ввода данных. Теперь гораздо проще видеть кадровые изменения в 1С:ЗУП. Также мы оказываем поддержку по 1С:ЗУП и по продукту Итилиум, который использует сервисный центр компании.
        </div>
    )
}